export default "__VITE_ASSET__CgKowQTl__"